export type DataDogRUMSampleRate = number

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSDataDogRUMampleRate(value: any): value is DataDogRUMSampleRate {
  return typeof value === 'number' && !Number.isNaN(value) && 0 <= value && value <= 100
}
export const DEFAULT_SAMPLE_RATE: DataDogRUMSampleRate = 100

export enum RUMContextKeys {
  DD_CTX_BASE_URL_CONSUMER = 'even.base_url.consumer',
  DD_CTX_BASE_URL_PARTNERPAGE = 'even.base_url.partnerpage',
  DD_CTX_BRAND_FROM_HOST = 'even.brand.from_host',
  DD_CTX_COMPANY_UUID = 'even.company.uuid',
  DD_CTX_LEAD_UUID = 'even.lead.uuid',
  DD_CTX_LEAD_RETURNING = 'even.lead.returning',
  DD_CTX_SESSION_UUID = 'even.session.uuid',
  DD_CTX_TRACKING_UUID = 'even.tracking.uuid',
}
